/**
 * companyBillingService — Tenant (şirket) tarafındaki lisans/tahsilat sorguları.
 *
 * BillingService.ts SuperAdmin'e özeldir (own-JWT + [SuperAdminOnly]); bu servis ise
 * çağıran şirketin kendi verisini `mainApi` (X-Company-Id header) üzerinden okur.
 * Şube manager panelindeki cihaz/ürün yenileme kartları buradan beslenir.
 */
import { mainApi } from '../config/apiClient';

/** Şube tahsilat kaydının bir ürün kalemi (snapshot). */
export interface BranchRenewalLine {
  name: string;
  quantity: number;
  lineTotal: number;
}

/** Bir şubeye ait AKTİF (ödenebilir) tahsilat kaydı. */
export interface BranchRenewalCase {
  /** Ödeme akışı için token (public /pay/renewal/:token). */
  token: string;
  sourceType: 'FiscalDevice' | 'Contract' | 'Manual';
  totalAmount: number;
  currency: string;
  expiryDate?: string | null;
  lines: BranchRenewalLine[];
}

/**
 * Verilen şubeye ait aktif tahsilat kayıtlarını döner (FiscalDevice dahil).
 * branchId boşsa boş dizi döner.
 */
export async function getBranchRenewalCases(
  branchId: string | null | undefined
): Promise<BranchRenewalCase[]> {
  if (!branchId) return [];
  const res = await mainApi.get('/api/Company/branch-renewal-cases', {
    params: { branchId },
  });
  const cases = res?.data?.cases;
  return Array.isArray(cases) ? (cases as BranchRenewalCase[]) : [];
}

/** Müşteri paneli bildirim zilindeki aktif tahsilat. */
export interface RenewalNoticeItem {
  id: number;
  token: string;
  title: string;
  message: string;
  totalAmount: number;
  currency: string;
  expiryDate?: string | null;
  sourceType: string;
  branchId?: string | null;
  daysRemaining: number;
}

/** Çağıran şirketin ödenmemiş tahsilatlarını döner. Zil bunu listeler. */
export async function getRenewalNotices(): Promise<RenewalNoticeItem[]> {
  const res = await mainApi.get('/api/Company/renewal-notices');
  const notices = res?.data?.notices;
  return Array.isArray(notices) ? (notices as RenewalNoticeItem[]) : [];
}

const companyBillingService = { getBranchRenewalCases, getRenewalNotices };
export default companyBillingService;
